import { setWebSocketHandlers } from '@/services/webSocketClient';
import { useWebSocketStore } from '@/stores/webSocket';

export function registerWebSocket() {
    // The plugin is now only a bridge between the transport-only webSocketClient
    // and Pinia actions that update application state and handle domain messages.
    setWebSocketHandlers({
        onConnected() {
            useWebSocketStore().SOCKET_ONOPEN();
        },
        onDisconnected() {
            useWebSocketStore().SOCKET_ONCLOSE();
        },
        onError(event) {
            useWebSocketStore().SOCKET_ONERROR(event);
        },
        onMessage(message) {
            useWebSocketStore().SOCKET_ONMESSAGE(message);
        },
    });
}
